<div class="progress" [className]="progress ? 'progress': 'no-progress'">
  <div class="indeterminate"></div>
</div>
